import React from "react";
import { ReactComponent as ChevronIcon } from "../../assets/icons/chevron.svg";
import Text from "../text";
import { PreviousContainer } from "./styled-component";

const PreviousButton = ({ onClick }: PreviousButtonProps) => {
  return (
    <PreviousContainer onClick={onClick}>
      <ChevronIcon />
      <Text
        size="16px"
        lineHeight="16px"
        weight={600}
        color="grey400"
        underline
      >
        Étape précédente
      </Text>
    </PreviousContainer>
  );
};

export default PreviousButton;
